import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { gql, useLazyQuery } from '@apollo/client';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useProductBasicDetails from '../useProductBasicDetails';
import { GET_MODULAR_SOFA_BUNDLE } from '../useModularPDPState/queries';
const GET_IS_MODULAR_BUNDLE_PRODUCT = gql`
  query getIsModularBundleOrPreconfigProduct($id: Int) {
    getIsModularBundleOrPreconfigProduct(id: $id) {
      productType
      isInModular
    }
  }
`;
const useModularDetails = t0 => {
  const $ = _c(28);
  const slug = t0 === undefined ? null : t0;
  const {
    loading: productBasicLoading,
    error: productBasicError,
    data: t1
  } = useProductBasicDetails(null, slug);
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const productBasicData = t2;
  const t3 = productBasicData?.id;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      id: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = !productBasicData?.id;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      noBatch: true
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t4 || $[6] !== t5) {
    t7 = {
      variables: t4,
      skip: t5,
      context: t6
    };
    $[5] = t4;
    $[6] = t5;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const {
    data,
    error,
    loading
  } = useSuspenseQuery(GET_IS_MODULAR_BUNDLE_PRODUCT, t7);
  const [getModularBundleData, t8] = useLazyQuery(GET_MODULAR_SOFA_BUNDLE);
  const {
    data: modularBundleData
  } = t8;
  let t9;
  if ($[8] !== data?.getIsModularBundleOrPreconfigProduct?.isInModular || $[9] !== getModularBundleData || $[10] !== modularBundleData?.modularBundle?.modular_parent?.slug || $[11] !== productBasicData) {
    t9 = () => {
      if (!productBasicData?.slug || !data?.getIsModularBundleOrPreconfigProduct?.isInModular) {
        return;
      }
      const finalSlug = productBasicData.meta.collectionSlug ? productBasicData.meta.collectionSlug.replace("collections/", "") : null;
      if (!finalSlug || (modularBundleData?.modularBundle?.modular_parent?.slug || "").includes(finalSlug)) {
        return;
      }
      getModularBundleData({
        variables: {
          slug: `${finalSlug}-modular`,
          ...getVisitorLocationQueryVariables()
        }
      });
    };
    $[8] = data?.getIsModularBundleOrPreconfigProduct?.isInModular;
    $[9] = getModularBundleData;
    $[10] = modularBundleData?.modularBundle?.modular_parent?.slug;
    $[11] = productBasicData;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = data?.getIsModularBundleOrPreconfigProduct?.isInModular;
  const t11 = productBasicData?.meta;
  const t12 = productBasicData?.slug;
  let t13;
  if ($[13] !== getModularBundleData || $[14] !== modularBundleData || $[15] !== t10 || $[16] !== t11 || $[17] !== t12) {
    t13 = [t10, t11, modularBundleData, getModularBundleData, t12];
    $[13] = getModularBundleData;
    $[14] = modularBundleData;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  useEffect(t9, t13);
  const t14 = productBasicLoading || loading;
  const t15 = productBasicError || error;
  const t16 = data?.getIsModularBundleOrPreconfigProduct?.isInModular;
  const t17 = data?.getIsModularBundleOrPreconfigProduct?.productType === "Bundle";
  const t18 = data?.getIsModularBundleOrPreconfigProduct?.productType === "Preconfig";
  const t19 = modularBundleData?.modularBundle?.preConfiguredProducts;
  let t20;
  if ($[19] !== t16 || $[20] !== t17 || $[21] !== t18 || $[22] !== t19) {
    t20 = {
      isModular: t16,
      isModularBundleProduct: t17,
      isModularPreConfigProduct: t18,
      preConfigProducts: t19
    };
    $[19] = t16;
    $[20] = t17;
    $[21] = t18;
    $[22] = t19;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] !== t14 || $[25] !== t15 || $[26] !== t20) {
    t21 = {
      loading: t14,
      error: t15,
      data: t20
    };
    $[24] = t14;
    $[25] = t15;
    $[26] = t20;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  return t21;
};
export default useModularDetails;